import React, { useMemo } from 'react';
import { ITimeBlockListing } from '../../../../entities-generated/models/time-block/time-block-listing';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { TimeBlockStatus } from '../../../../entities-generated/common/time-block-status';
import { BadgeType } from '../../../../framework/components/bwj-listing/entities';

interface ITimeBlockListItemProps {
  block: ITimeBlockListing;
  onToggleSelection: (block: ITimeBlockListing) => void;
}

export const TimeBlockListItem: React.FunctionComponent<ITimeBlockListItemProps> = (props) => {
  const { block } = props;
  const heading = useMemo(() => {
    return block.sequenceNumber < 13
    ? `${block.sequenceNumber} - Morning`
    : `${block.sequenceNumber} - Afternoon`
  }, [block]);
  const availability = useMemo(() => {
    const content: string[] = [block.status === TimeBlockStatus.Available ? 'Available' : 'Reserved'];
    if(block.status === TimeBlockStatus.Available) {
      const para = block.isBillableTime ? 'for billable work' : 'for non-billable activity';
      content.push(para);
    }
    return content.join(' ');
  }, [block]);

  return (
    <BwjListing
      badge={{
        type: BadgeType.Icon,
        content: block.isSelected ? 'RadioBtnOn' : 'RadioBtnOff'
      }}
      invalid={block.status === TimeBlockStatus.BlackedOut}
      selected={block.isSelected}
      heading={heading}
      secondaryLine={availability}
      data={block}
      onClick={props.onToggleSelection}
    />
  );
};
